var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Login',{attrs:{"password-icon":_vm.passwordIconWeb,"password-type":_vm.passwordType,"error":_vm.error,"loading":_vm.loading},on:{"onSwitch":function($event){_vm.hidePassword = !_vm.hidePassword},"onLogin":_vm.login_submit}})}
var staticRenderFns = []

export { render, staticRenderFns }